import type { BreadcrumbItem } from '@cubemeet/ui';
import { resolveCityKey, getCityDisplayNameZH } from '../../shared/cities';

export const buildPostBreadcrumb = (post: any, t?: (key: string) => string): BreadcrumbItem[] => {
  // Home > Kyoto > 指南 > Title
  const homeLabel = t ? t('travelPostDetail.breadcrumbs.home') : '首頁';
  const items: BreadcrumbItem[] = [{ label: homeLabel, to: '/' }];

  const cityAlias = post?.content_json?.city || post?.city;
  const cityKey = resolveCityKey(typeof cityAlias === 'string' ? cityAlias : '');
  if (cityKey) {
    items.push({ label: getCityDisplayNameZH(cityKey), to: `/city/${cityKey}` });
  }

  const type = post?.content_json?.type || post?.type;
  if (String(type || '').toLowerCase() === 'guide') {
    const guideLabel = t ? t('travelPostDetail.breadcrumbs.guide') : '指南';
    items.push({ label: guideLabel, to: '/travel_post/guide' });
  }

  const title = post?.title || '詳情';
  items.push({ label: title });
  return items;
};
